require('../resize/resizeConfig');
require('../resize/resizeService');

angular.module('app.shared.infiniteCarousel.infiniteCarouselController', [
  'app.shared.resize.resizeService',
  'app.shared.resize.RESIZE_CONFIG'
])
  .controller('app.shared.infiniteCarousel.infiniteCarouselController', [
    '$scope',
    '$element',
    'app.shared.resize.resizeService',
    'RESIZE_CONFIG',
    function ($scope, $element, resizeService, RESIZE_CONFIG) {
      "use strict";

      let pages, eventListeners, itemsPerPage,
        currentPageIndex = 0;

      function getItemsPerPage(itemWidth, pageWidth) {
        return Math.floor(pageWidth / itemWidth);
      }

      $scope.nextPage = function () {
        $element.removeClass('backwards').addClass('forward');
        currentPageIndex++;
        currentPageIndex = currentPageIndex > pages.length - 1 ?
          0 : currentPageIndex % (pages ? pages.length : 0);
        $scope.currentPage = pages ? pages[currentPageIndex] : [];
      };

      $scope.prevPage = function () {
        $element.removeClass('forward').addClass('backwards');
        currentPageIndex--;
        currentPageIndex = currentPageIndex > -1 ?
          currentPageIndex % (pages ? pages.length : 0) :
          pages.length - 1;
        $scope.currentPage = pages ? pages[currentPageIndex] : [];
      };

      eventListeners = [
        $scope.$on(
          RESIZE_CONFIG.EVENT_NAME,
          /**
           * @param e
           * @param {*} size
           */
          (e, size) => {
            $element.removeClass('backwards').removeClass('forward');
            itemsPerPage = getItemsPerPage($scope.itemWidth, size.width);
            pages = _.chunk($scope.items, itemsPerPage);
            currentPageIndex = Math.floor(currentPageIndex * itemsPerPage / itemsPerPage);
            $scope.currentPage = pages[currentPageIndex];
          })
      ];

      $scope.$watchCollection('items', function (items) {
        if (items) {
          itemsPerPage = getItemsPerPage(
            $scope.itemWidth,
            resizeService.getSize($element).width
          );
          pages = _.chunk(items, itemsPerPage);
          $scope.currentPage = pages[0];
        }
      });


      // Remove Event Listeners
      $scope.$on('$destroy', function () {
        _.invokeMap(eventListeners, _.call);
      });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/infiniteCarousel/infiniteCarouselController.js